import { ObjectType } from '@convergence/types';
import { AnalysisValueProps } from './types';
import { AnalysisSwitchValue } from './analysis-switch-value';

export function AnalysisObject(props: AnalysisValueProps<ObjectType>) {
  const fields = Object.entries(props.value._fields) ?? [];

  return (
    <div className="border-l">
      {props.name}
      {fields.map(([key, value]) => (
        <div className="pl-4">
          <AnalysisSwitchValue
            name={key}
            tree={props.tree}
            value={value}
            propertyPath={[...props.propertyPath, '_fields', key]}
          />
        </div>
      ))}
    </div>
  );
}
